//import { useState } from 'react';
import React from "react";
import { IFacetteFiltre, IFacettes } from "../models/interfaces/IFacette";
import "./CpntFacette.scss";
import CpntFacette from "./CpntFacette";



interface IProps {
  Facettes: IFacettes;
  FacettesSelected?: IFacetteFiltre[];
  onChange: (filtre: IFacetteFiltre,checked: boolean ) => void;
  getLibelleFacette: (filtre: string ) => string;
}

const CpntFacettes: React.FC<IProps> = ({
  onChange,
  getLibelleFacette,
  Facettes,
  FacettesSelected
}) => {
  
    return (
      Facettes &&
      <>

{//Toutes les facettes
Object.keys(Facettes).sort().map((Facette, idx) => (
  <div key={idx} style={{ display: 'flex', flexWrap: 'wrap' }}>
    {//Pour Chaque Facette
    Object.values(Facettes).map((item, idx) => (
      <div key={"ctn_" + Facette?.toLowerCase() + idx} style={{ display: 'flex', flexWrap: 'wrap' }}>
        {
          item.map((obj, idx) => (
            <CpntFacette key={idx} 
            Libelle={getLibelleFacette(obj.Libelle)}
            // cssClassOuterBox="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
            cssClassInnerBox={'m-1 facette-color-' + obj.Libelle}
            Quantite={obj.Quantite}
            SkeletonVisible={false}
            FacetteSelected={FacettesSelected?.some(fs => fs.filtreName === Facette?.toLowerCase() && fs.filtreValue === obj.Filtre) ? true : false} 
            onChange={(event) =>
              onChange(
                {
                  filtreName: Facette?.toLowerCase(),
                  filtreValue: obj.Filtre
                },
                event.target.checked
              )} 
              />
          ))
        }
        {/* {item.map((obj, idx) => (
          <label 
            key={"chk_" + Facette?.toLowerCase() + idx}
            // style={{
            //   backgroundColor: getColorFacette(obj?.Libelle)
            // }}
            className={`btn mx-1 facette-style ${'facette-color-' + obj?.Libelle} ${FacettesSelected?.some(fs => fs.filtreName === Facette?.toLowerCase() && fs.filtreValue === obj.Filtre) && "facette-selected" }`}
          >
            <input
              type="checkbox"
              className="btn-check"
              id={`btn-check-${idx}`}
              onChange={(event) =>
                onChange(
                  {
                    filtreName: Facette?.toLowerCase(),
                    filtreValue: obj.Filtre
                  },
                  event.target.checked
                )}
              checked={FacettesSelected?.some(fs => fs.filtreName === Facette?.toLowerCase() && fs.filtreValue === obj.Filtre) ? true : false}
            />
            <span style={{ flex: 1, textAlign: "center" }}>
              {getLibelleFacette(obj.Libelle)}
            </span>
            <span className={`facette-style-number`}
              // style={{
              //   color: getColorFacette(obj?.Libelle),
              // }}
            >
              {`${obj?.Quantite}`}
            </span>
          </label>
        ))} */}
      </div>
    ))}
  </div>
))}
      </>
  );
 
  };

  export default CpntFacettes;
